/** @format */

'use strict';

(function () {
  initcourseUnitTypeJsDataModel.$inject = ["courseUnitTypeJsDataModel"];
  courseUnitTypeJsDataModel.$inject = ["DS", "$http", "$log"];
  angular.module('sis-components.model.courseUnitType', ['js-data']).factory('courseUnitTypeJsDataModel', courseUnitTypeJsDataModel).run(initcourseUnitTypeJsDataModel);

  /**
   * @ngInject
   */
  function courseUnitTypeJsDataModel(DS, $http, $log) {
    var model = DS.defineResource({
      idAttribute: 'urn',
      name: 'courseUnitType',
      endpoint: '/kori/api/cached/codebooks/urn:code:course-unit-type',
      watchChanges: false
    });
    model.lazyGetAll = _.once(function () {
      return $http.get(model.endpoint).then(function (response) {
        model.inject(_.values(response.data));
        return model.getAll();
      }).catch(function (error) {
        $log.error(error);
      });
    });
    return model;
  }

  /**
   * @ngInject
   */
  function initcourseUnitTypeJsDataModel(courseUnitTypeJsDataModel) {
    courseUnitTypeJsDataModel.lazyGetAll();
  }
})();